import React from 'react';
function DefaultErrorComponent({ error, info }) {
    return (React.createElement("div", { className: 'error' },
        React.createElement("div", null, "An Error Occurred"),
        React.createElement("div", null, error ? error.toString() : ''),
        React.createElement("div", null, info ? JSON.stringify(info, null, 2) : '')));
}
export default DefaultErrorComponent;
//# sourceMappingURL=DefaultErrorComponent.js.map